import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import './Sidebar.css';

const Sidebar = () => {
  const { user } = useSelector(state => state.auth); // Redux auth state
  const navigate = useNavigate();
  const location = useLocation();
  const [activeItem, setActiveItem] = useState('Dashboard');

  const userMenuItems = [
    { id: 'Dashboard', label: 'Dashboard', icon: '📊', path: '/dashboard' },
    { id: 'MyLearning', label: 'My Learning', icon: '📚', path: '/my-learning' },
    { id: 'MyResume', label: 'My Resume', icon: '📄', path: '/my-resume' },
    { id: 'Practice', label: 'Practice', icon: '🎯', path: '/practice' },
    { id: 'jobs', label: 'Job Portal', icon: '💼', path: '/jobs' }
  ];

  const adminMenuItems = [
    { id: 'Dashboard', label: 'Dashboard', icon: '📊', path: '/dashboard' },
    { id: 'management', label: 'Management', icon: '🎯', path: '/management' },
    { id: 'reports', label: 'Reports', icon: '💼', path: '/reports' }
  ];

  // Update active item based on current route
  useEffect(() => {
    if (!user) return; // Early exit if no user

    let currentItem;
    if (user.role === "ADMIN") {
      currentItem = adminMenuItems.find(item => item.path === location.pathname);
    } else if (user.role === "STUDENT" || user.role === "USER") {
      currentItem = userMenuItems.find(item => item.path === location.pathname);
    }

    if (currentItem) {
      setActiveItem(currentItem.id);
    }
  }, [location.pathname, user]);

  const handleItemClick = (item) => {
    try {
      setActiveItem(item.id);
      navigate(item.path);
    } catch (error) {
      console.error('Navigation error:', error);
    }
  };

  if (!user) return null; // Don't render sidebar if not logged in

  const menuItems = user.role === "ADMIN" ? adminMenuItems : userMenuItems;

  return (
    <div className="sidebar">
      {/* Logo Section */}
      <div className="sidebar-header">
        <div className="logo">
          <span className="logo-icon">⚡</span>
          <span className="logo-text">NRKS</span>
        </div>
      </div>

      {/* Navigation Menu */}
      <nav className="sidebar-nav">
        <ul className="nav-list">
          {menuItems.map((item) => (
            <li key={item.id} className="nav-item">
              <button
                className={`nav-link ${activeItem === item.id ? 'active' : ''}`}
                onClick={() => handleItemClick(item)}
              >
                <span className="nav-icon">{item.icon}</span>
                <span className="nav-label">{item.label}</span>
              </button>
            </li>
          ))}
        </ul>
      </nav>

      {/* Help Section */}
      <div className="sidebar-footer">
        <button className="help-button">
          <span className="help-icon">❓</span>
          <span className="help-label">Help</span>
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
